var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAddSuccess = function SvgAddSuccess(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5455 18.4549V17.1822C15.5455 16.5071 15.2773 15.8596 14.7999 15.3823C14.3225 14.9049 13.6751 14.6367 13 14.6367H8.54545C7.87036 14.6367 7.22291 14.9049 6.74555 15.3823C6.26818 15.8596 6 16.5071 6 17.1822V18.4549",
    stroke: "#04A74D",
    strokeWidth: 1.27273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.772 12.0909C12.1778 12.0909 13.3175 10.9513 13.3175 9.54545C13.3175 8.13964 12.1778 7 10.772 7C9.3662 7 8.22656 8.13964 8.22656 9.54545C8.22656 10.9513 9.3662 12.0909 10.772 12.0909Z",
    stroke: "#04A74D",
    strokeWidth: 1.27273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.5002L17.3735 13.0004L20.1205 10",
    stroke: "#04A74D",
    strokeWidth: 1.37349,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAddSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add-success.d7b9b4155c17bd8d1d2c0a33bfdf3935.svg";